import {
  ICommodity,
  IDangerousGood,
  IDgdDictionnary,
  IRequirementSearchTemplate,
  ISearchTemplate,
  MeasurementSystemEnum,
} from "@cai-services";
import { AircraftCategory } from "../_enums/aircraft-enum";
import { Office } from "./office.model";
import { SearchItemTemplate } from "./search-item-template.model";
import { TypeOfProduct } from "./type-of-product.model";

export class SearchTemplate implements ISearchTemplate {
  isSearch: boolean;
  isHistory: boolean;
  searchDate: Date;
  // can be airport OR city, based on isOriginByCity
  origin: string;
  isOriginByCity: boolean;
  originCountry: string;
  // can be airport OR city, based on isDestinationByCity
  destination: string;
  isDestinationByCity: boolean;
  destCountry: string;
  searchTemplateId: number;
  dangerousGoods: IDangerousGood[];
  dgdDictionnaries: IDgdDictionnary[];
  typeOfProduct: TypeOfProduct;
  office: Office;
  specialHandlingCode: string;
  searchItemTemplates: SearchItemTemplate[];
  craftType: AircraftCategory;
  volume: number;
  weight: number;
  commodities: ICommodity[];
  requirements: IRequirementSearchTemplate[];
  chargeableWeight: number;
  isSearchTemplate: boolean;
  totalVolume: number;
  totalWeight: number;
  measurementSystem: MeasurementSystemEnum;
}
